import { Component } from 'react';
import { Container, Button, Row, Col } from 'reactstrap';
import Toolbar from '../../basic/Toolbar';
import { ToolbarLinkButton } from '../../basic/Button';
import { AMS360SetupsModel, AMS360SetupsClient } from '../../../client/ApiClient';
import { DataTable, DataRow, DataCell } from 'components/basic/DataTable';

interface AMS360SetupsListState {
    ndt: AMS360SetupsModel[];
}

class AMS360SetupsList extends Component<{}, AMS360SetupsListState> {
    private client: AMS360SetupsClient = new AMS360SetupsClient();

    constructor(props: {}) {
        super(props);
        this.state = {
            ndt: []
        };
    }

    componentDidMount() {
        this.getList();
    }

    getList = () => {
        this.client.listAll().then(result => {
            this.setState({ ndt: result! });
        }).catch(err => {
            // Optionally handle error
        });
    }

    isNullOrEmpty(value: string | null | undefined): boolean {
        return value === null || value === undefined || value.toString().trim() === '';
    }

    handleCreate = () => {
        window.location.href = '/tools/ndt/epic/new';
    }

    public render() {
        return (
            <Container className="mt-4">
                <Row className="mb-2">
                    <Col xs={8} md={9}><h4>AMS360 Setup</h4></Col>
                    <Col xs={4} md={3}><Button color='secondary' className='submit-button-orange' onClick={this.handleCreate}>Create New AMS360 Setup</Button></Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={12} md={12}>
                        <DataTable>
                            <thead>
                                <tr>
                                    <th className="number-column">#</th>
                                    <th>Source Database</th>
                                    <th>Target Database</th>
                                    <th>Status</th>
                                    <th>Date Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.ndt!.map((item, index) => (
                                    <DataRow id={item.actionId} key={item.actionId} onClick={() => window.location.href = `/tools/ndt/epic/${item.actionId}`} style={{ cursor: 'pointer' }}>
                                        <DataCell className="number-column">{index + 1}</DataCell>
                                        <DataCell>{item.sourceDatabaseName}</DataCell>
                                        <DataCell>{item.targetDatabaseName}</DataCell>
                                        <DataCell>{item.status}</DataCell>
                                        <DataCell>{item.startTime?.toLocaleDateString('en-US')}</DataCell>
                                    </DataRow>
                                ))}
                            </tbody>
                        </DataTable>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default AMS360SetupsList;